import {
  httpPatchWithStatus,
  isSuccessStatus,
} from '@sola/shared-utils/httpClient.ts';

import { MY_API_BASE } from '../constants.ts';

// Trailing slash: same CloudFront OAC / trailingSlash reason as entries.
export const routeContentFeedProfile = () =>
  `${MY_API_BASE}/content-feed/profile/`;

/**
 * Ensures the supporter has a profile on the Global Content API.
 * Fire-and-forget — failures do not block the feed from rendering.
 * Called on feed load to guarantee the user can react/comment.
 *
 * PATCH /api/content-feed/profile/
 *
 * The server resolves the display name from the session; no client body needed.
 */
export const ensureContentFeedProfile = async (): Promise<void> => {
  try {
    const url = routeContentFeedProfile();
    const { statusCode } = await httpPatchWithStatus<unknown>(
      url,
      {},
      {
        signRequest: true,
      },
    );

    if (!isSuccessStatus(statusCode)) {
      // Non-critical: log but don't throw
      console.warn('[ensureContentFeedProfile] sync failed:', statusCode);
    }
  } catch {
    // Fire-and-forget: swallow errors — if profile sync fails,
    // reactions/comments will fail with a 403 but the feed still works.
  }
};
